module.exports = __webpack_public_path__ + "media/images/SS-icon-checkmark-cropped-d8289494.gif";